import type { TransportOption, TripStop } from 'tripPlanner/api/types'
import type { FlightSearchDrawerParams } from './flightSearchDrawerParams'
import { getFlightSearchDrawerParamsFromTransport } from './flightSearchDrawerParams'

export interface StopFlightSearchDefaults {
  flightSearchParams: FlightSearchDrawerParams
  existingFlights?: Array<TransportOption>
}

function isFlightTransportOption(option: TransportOption): boolean {
  return option.type?.toLowerCase() === 'flight'
}

function getPreviousTripStop(stops: Array<TripStop>, stop: TripStop): TripStop | undefined {
  const orderedStops = [...stops].sort((a, b) => a.stopSeq - b.stopSeq)
  const stopIndex = orderedStops.findIndex(candidate => candidate.id === stop.id)
  return stopIndex > 0 ? orderedStops[stopIndex - 1] : undefined
}

export function getAdjacentStopFlightSearchDefaults(stops: Array<TripStop>, stop: TripStop): StopFlightSearchDefaults | undefined {
  const previousStop = getPreviousTripStop(stops, stop)
  const transport = previousStop?.transports?.find(candidate => candidate.options.some(isFlightTransportOption))
  const option = transport?.options.find(isFlightTransportOption)
  if (!transport || !option) return undefined

  return {
    flightSearchParams: getFlightSearchDrawerParamsFromTransport(option, transport),
    existingFlights: transport.options,
  }
}

export function getStopFlightSearchDefaults(stops: Array<TripStop>, stop: TripStop): StopFlightSearchDefaults {
  const adjacentFlightDefaults = getAdjacentStopFlightSearchDefaults(stops, stop)
  if (adjacentFlightDefaults) return adjacentFlightDefaults

  const previousStop = getPreviousTripStop(stops, stop)

  return {
    flightSearchParams: {
      originAirportName: previousStop?.placeName,
      destinationAirportName: stop.placeName,
      departureDate: previousStop ? stop.startDate : undefined,
    },
  }
}
